/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EditBatchMissionPayloadModel model module.
 * @module model/EditBatchMissionPayloadModel
 * @version v1.0.0
 */
class EditBatchMissionPayloadModel {
    /**
     * Constructs a new <code>EditBatchMissionPayloadModel</code>.
     * @alias module:model/EditBatchMissionPayloadModel
     */
    constructor() { 
        
        EditBatchMissionPayloadModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EditBatchMissionPayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EditBatchMissionPayloadModel} obj Optional instance to populate.
     * @return {module:model/EditBatchMissionPayloadModel} The populated <code>EditBatchMissionPayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EditBatchMissionPayloadModel();

            if (data.hasOwnProperty('scheduleTime')) {
                obj['scheduleTime'] = ApiClient.convertToType(data['scheduleTime'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
        }
        return obj;
    }


}

/**
 * set cron job schedule Time
 * @member {Number} scheduleTime
 */
EditBatchMissionPayloadModel.prototype['scheduleTime'] = undefined;

/**
 * status
 * @member {module:model/EditBatchMissionPayloadModel.StatusEnum} status
 */
EditBatchMissionPayloadModel.prototype['status'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
EditBatchMissionPayloadModel['StatusEnum'] = {

    /**
     * value: "confirmXls"
     * @const
     */
    "confirmXls": "confirmXls",

    /**
     * value: "finish"
     * @const
     */
    "finish": "finish",

    /**
     * value: "pending"
     * @const
     */
    "pending": "pending",

    /**
     * value: "pendingBatch"
     * @const
     */
    "pendingBatch": "pendingBatch",

    /**
     * value: "processBatchFile"
     * @const
     */
    "processBatchFile": "processBatchFile"
};



export default EditBatchMissionPayloadModel;

